import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import attendancePolicies from 'modules/attendance/store/collections/policies'
import attendanceSettingsCollection from 'modules/attendance/store/collections/settings'
import type AttendancePolicy from 'modules/attendance/store/models/AttendancePolicy'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

interface UseFetchDataType {
  loading: boolean
  isNotFound: boolean
  attendancePolicy: AttendancePolicy | null | undefined
  currentSetting: AttendanceSetting | null | undefined
  attendanceSettings: AttendanceSetting[] | null
}

const useFetchData = (settingId: number | 'default'): UseFetchDataType => {
  const { loading } = useAsyncData(
    () =>
      Promise.all([
        attendancePolicies.fetch(),
        attendanceSettingsCollection.reset([]),
        attendanceSettingsCollection.fetch(),
      ]),
    []
  )

  const isDefault = settingId === 'default'
  const attr = isDefault ? { default: true } : { id: +settingId }
  const currentSetting = !loading ? attendanceSettingsCollection.find(attr) : null
  const isNotFound = !loading && !currentSetting
  const attendancePolicyId = currentSetting?.attributes.attendance_employees_policy_id
  const attendancePolicy = attendancePolicyId
    ? attendancePolicies.find({ id: +attendancePolicyId })
    : null
  const attendanceSettings = attendancePolicyId
    ? attendanceSettingsCollection.orderByEffectiveAt(attendancePolicyId)
    : null

  return {
    loading,
    isNotFound,
    attendancePolicy,
    currentSetting,
    attendanceSettings,
  }
}

export default useFetchData
